
		import Async from 'preact-cli/async-component';

		function load(cb) {
			require.ensure([], function (require) {
				cb( require("!!../../../node_modules/babel-loader/lib/index.js??ref--0!./index.js") );
			}, "route-logout");
		}

		export default Async(load);
	


//////////////////
// WEBPACK FOOTER
// ./routes/logout/index.js
// module id = ZHBS
// module chunks = 7